import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["shadowedDragPreviewRef"];
import { createContext, useContext, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const DragPreviewContext = /*#__PURE__*/createContext({
  shadowedDragPreviewRef: null,
  dragPreviewZIndex: '1'
});
export const DragPreviewProvider = ({
  children,
  dragPreviewZIndex
}) => {
  const shadowedDragPreviewRef = useRef(null);
  return /*#__PURE__*/_jsx(DragPreviewContext.Provider, {
    value: {
      shadowedDragPreviewRef,
      dragPreviewZIndex
    },
    children: children
  });
};
export function useShadowedDragPreviewRefToSet() {
  const {
    shadowedDragPreviewRef
  } = useContext(DragPreviewContext);
  return shadowedDragPreviewRef;
}
export function useDragPreviewContext() {
  const _useContext = useContext(DragPreviewContext),
    {
      shadowedDragPreviewRef
    } = _useContext,
    restContext = _objectWithoutPropertiesLoose(_useContext, _excluded);
  if (!shadowedDragPreviewRef) {
    throw new Error('shadowedDragPreviewRef is not set');
  }
  return Object.assign({
    shadowedDragPreviewRef
  }, restContext);
}